<template>
  <div
    :class="baseLayoutSectionClasses"
    :style="[isSticky && stickyOffset ? stickyStyles : {}]"
    class="base-layout-section"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  width: {
    type: String,
    default: "",
    validator: (value) => [
      "",
      "secondary",
      "full-width",
      "one-half",
      "one-third",
    ].includes(value),
  },
  isSticky: {
    type: Boolean,
    default: false,
  },
  stickyOffset: {
    type: [String, Number, null],
    default: null,
  },
});

const baseLayoutSectionClasses = computed(() => ({
  [`base-layout-section--width-${props.width}`]: true,
  "base-layout-section--is-sticky": props.isSticky,
}));

const stickyStyles = computed(() => {
  if (props.stickyOffset == null) {
    return {};
  }

  const normalizedOffset = String(props.stickyOffset).replace("px", "");

  return {
    top: `${normalizedOffset}px`,
  };
});
</script>

<style lang="scss">
@import "./base-layout-section.scss";
</style>
